import { requestApi } from "@/api/core";
import { dynamicDispatcher } from "@/libs/util";

export const coreBoxInTaskList = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "taskCore/CoreBoxInTaskList",
      method: "post",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const getMobListFields = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "taskCore/GetMobListFields",
      method: "GET",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const getCoreList = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "taskCore/GetCoreList",
      method: "post",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const getListFields = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "taskCore/GetListFields",
      method: "GET",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const getSearchFields = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "taskCore/GetSearchFields",
      method: "GET",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const getDetailFields = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "taskCore/GetDetailFields",
      method: "GET",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const getEditFields = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "taskCore/getEditFields",
      method: "GET",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};
